export default __webpack_public_path__ + "static/media/ab_bg.32dce242.png";